import { useState } from "react";
import { useAuth } from "../../hooks/auth";
import CloseIcon from "../close-icon";
import SmileIcon from "../smile-icon";

export const Feedback: React.FC = () => {
  const { user } = useAuth();
  const [showFeedback, setShowFeedback] = useState(() => {
    const feedbackClosed = localStorage.getItem("@Poxalulu:feedbackClosed");
    return !feedbackClosed;
  });
  const feedbackUrl = process.env.REACT_APP_FEEDBACK_FORM_URL!;

  function handleCloseFeedback() {
    localStorage.setItem("@Poxalulu:feedbackClosed", "true");
    setShowFeedback(false);
  }

  if (!feedbackUrl || user.role !== "student" || !showFeedback) return null;

  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        right: "0",
        top: "50%",
        zIndex: 40,
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        transform: "translateY(-50%)",
      }}
    >
      <button
        aria-label="Fechar"
        type="button"
        style={{ background: "transparent" }}
        onClick={handleCloseFeedback}
      >
        <CloseIcon />
      </button>

      <a
        href={feedbackUrl}
        target="blank"
        style={{
          display: "flex",
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingTop: "16px",
          paddingBottom: "16px",
          flexDirection: "column",
          gap: "8px",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#6e61c6",
          borderTopLeftRadius: "10px",
          borderBottomLeftRadius: "10px",
          textDecoration: "none",
        }}
      >
        <p
          style={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#ffffff",
            writingMode: "vertical-lr",
            transform: "rotate(180deg)",
          }}
        >
          Feedback
        </p>

        <SmileIcon />
      </a>
    </div>
  );
};
